import { Check, MoreHorizontal, RotateCcw } from "lucide-react";
import type { ChaveDoQuadro } from "@bookdental/schemas";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@bookdental/ui";
import { QUADROS } from "./use-quadros-da-ficha";

type Props = {
  atual: ChaveDoQuadro;
  /** Quadros que a pessoa pode ver e ainda não estão na tela. */
  opcoes: ChaveDoQuadro[];
  personalizado: boolean;
  onTrocar: (nova: ChaveDoQuadro) => void;
  onRestaurar: () => void;
};

/** O "⋯" do quadro: trocar por outro (sem repetir o que já está na tela) ou voltar ao padrão. */
export function MenuDoQuadro({ atual, opcoes, personalizado, onTrocar, onRestaurar }: Props) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label={`Trocar o quadro ${QUADROS[atual].titulo}`}
          title="Trocar quadro"
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-zinc-400 transition-colors hover:bg-zinc-100 hover:text-zinc-700 dark:hover:bg-muted dark:hover:text-foreground"
        >
          <MoreHorizontal className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64 border border-zinc-200 bg-white shadow-lg dark:border-border dark:bg-card">
        <DropdownMenuLabel className="text-xs font-semibold text-muted-foreground">Trocar quadro</DropdownMenuLabel>
        <DropdownMenuItem disabled className="gap-2">
          <Check className="h-4 w-4 text-brand-600" />
          {QUADROS[atual].titulo}
        </DropdownMenuItem>
        {opcoes.map((c) => {
          const { titulo, icone: Icone, emBreve } = QUADROS[c];
          return (
            <DropdownMenuItem key={c} onSelect={() => onTrocar(c)} className="gap-2">
              <Icone className="h-4 w-4 text-zinc-500" />
              <span className="flex-1">{titulo}</span>
              {emBreve && <span className="text-[10px] font-semibold uppercase text-zinc-400">Em breve</span>}
            </DropdownMenuItem>
          );
        })}
        {personalizado && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onSelect={onRestaurar} className="gap-2">
              <RotateCcw className="h-4 w-4 text-zinc-500" />
              Restaurar padrão
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
